import React from 'react';

import * as Sentry from '@sentry/react';
import {
  QueryClientProvider,
  QueryErrorResetBoundary,
} from '@tanstack/react-query';
import { I18nextProvider } from 'react-i18next';

// Routing components
import { queryClient, startupMaintenanceFilter } from '@api/api.queryClient';
import { FullPageLoadingSpinner } from '@components/spinners';
import {
  AuthProvider,
  CacheBuster,
  UnderMaintenance,
} from '@components/utilComponents';
import { i18n } from '@locales/i18n';
import { Error500Page } from '@pages/Service';

const RouterProvider = React.lazy(async () => {
  const [{ RouterProvider }, { router }] = await Promise.all([
    import('@navigation/RouterProvider'),
    import('@navigation/router'),
  ]);
  // Возвращаем компонент с уже переданным router
  return {
    default: () => <RouterProvider router={router} />,
  };
});
export const App = () => {
  return (
    <Sentry.ErrorBoundary fallback={<Error500Page />}>
      <React.StrictMode>
        <CacheBuster
          loadingComponent={<FullPageLoadingSpinner backdrop={false} />}
        >
          <QueryClientProvider client={queryClient}>
            <I18nextProvider i18n={i18n}>
              <QueryErrorResetBoundary>
                {({ reset }) => (
                  <Sentry.ErrorBoundary
                    fallback={<UnderMaintenance />}
                    onReset={reset}
                    beforeCapture={(_scope, error) =>
                      startupMaintenanceFilter.markHandled(error)
                    }
                  >
                    {/* Suspense покрывает загрузку AuthProvider + RouterProvider */}
                    <React.Suspense
                      fallback={<FullPageLoadingSpinner backdrop={false} />}
                    >
                      <AuthProvider>
                        <RouterProvider />
                      </AuthProvider>
                    </React.Suspense>
                  </Sentry.ErrorBoundary>
                )}
              </QueryErrorResetBoundary>
            </I18nextProvider>
          </QueryClientProvider>
        </CacheBuster>
      </React.StrictMode>
    </Sentry.ErrorBoundary>
  );
};
